import { faAlignLeft, faBookOpen, faCalendarAlt, faCommentAltDots, faInfoSquare, faQuestionSquare, faTasks } from "@fortawesome/pro-duotone-svg-icons";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ModalFeedBack from "../../../../components/ModalFeedBack";
import { Menu } from "../../../../interfaces/entities/UnimedAcolhe/UnimedAcolheMenu";
import { UnimedAcolheButtonsProps } from "../../../../interfaces/props/SaudeBemEstar/UnimedAcolhe/UnimedAcolheButtonsProps";
import { getBenef } from "../../../../Store/storages/BeneficiarioStorage";
import UnimedAcolheButton from "./UnimedAcolheButton";

function UnimedAcolheButtons(props: UnimedAcolheButtonsProps) {

    const benefAtivo: boolean = getBenef()?.indStatusBenef || false;
    const navigate = useNavigate();

    const [modalFeedback, setModalFeedback] = useState<null | {
        icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
        closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
    }>(null);

    const openModal = (
        icon: 'error' | 'success' | 'warning', title: string, subtitle: string, textButton: string, closeAction: () => void, buttonAction: () => void
    ) => {
        setModalFeedback({
            icon: icon,
            title: title,
            subTitle: subtitle,
            textButton: textButton,
            showButtonModal: false,
            closeAction: closeAction,
            buttonAction: buttonAction
        });
    }

    const handlePath = (menu: string) => {
        switch (menu) {
            case "SaudeEmocionalOqueEPage":
                return '/saudeBemEstar/unimedAcolhe/oqueEUnimedAcolhe';
            case "SaudeEmocionalManualAtendimentoPage":
                return '/saudeBemEstar/unimedAcolhe/manualDeAtendimento';
            case "SaudeEmocionalRefazerAvaliacaoPage":
                return '/saudeBemEstar/unimedAcolhe/autoAvaliacao/refazer';
            case "SaudeEmocionalAvaliacao":
                return '/saudeBemEstar/unimedAcolhe/autoAvaliacao';
            case "SaudeEmocionalAgendamentoTrocaProfissionalPage":
                return '/saudeBemEstar/unimedAcolhe/meuPsicoterapeuta';
            case "SaudeEmocionalDiarioPage":
                return '/saudeBemEstar/unimedAcolhe/meuDiario/inicio';
            case "SaudeEmocionalAgendamentoPage":
                return '/saudeBemEstar/unimedAcolhe/agendamentos'
            case "SaudeEmocionalMeusAgendamentosPage":
                return '/saudeBemEstar/unimedAcolhe/agendamentos/lista'
            default:
                return '';
        }
    }

    const handleClick = (menu: Menu) => {
        if (benefAtivo) {
            if (menu.linkDeRedirecionamento.startsWith('http')) window.open(menu.linkDeRedirecionamento, '_blank')
            else {
                const page = menu.linkDeRedirecionamento !== "" ? menu.linkDeRedirecionamento : handlePath(menu.component);
                navigate(page);
            }
        } else {
            openModal('error', 'Atenção!',
                'Este plano está inativo e, portanto, não é possível utilizar este serviço. Em caso de dúvidas, entre em contato pelos nossos canais de atendimento.',
                '', () => setModalFeedback(null), () => setModalFeedback(null));
        }
    }

    return (
        <>
            <ul className="unimed-acolhe-buttons-holder">
                {
                    props.menu.map(item => item.menus.map(menu => (
                        <UnimedAcolheButton
                            key={menu.component}
                            icon={menu.icon}
                            handleClick={() => handleClick(menu)}
                            name={menu.title} 
                        />))
                    )
                }
            </ul>
            <ModalFeedBack
                showModal={!!modalFeedback}
                handleShowModal={modalFeedback?.closeAction}
                title={modalFeedback?.title as string}
                subTitle={modalFeedback?.subTitle as string}
                icon={modalFeedback?.icon as 'success' | 'error' | 'warning'}
                showButtonModal={modalFeedback?.showButtonModal}
                textButton={modalFeedback?.textButton as string}
                handleButtonModal={modalFeedback?.buttonAction}
            />
        </>
    )
}

export default UnimedAcolheButtons;